import {
  ApiBlueprint,
  AppRootElementBlueprint,
  createApiFactory,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { RequirePermission } from '@backstage/plugin-permission-react';
import { noticesReadPermission } from '@internal/backstage-plugin-neo4j-notices-common';
import { NoticesRestApi } from './apis';
import { NoticesPopUp } from './components/NoticesPopUp';
import { NOTICES_BASE_PATH } from './const';
import { rootRouteRef } from './routes';
import { noticesApiRef } from './types';

// ── API (→ global API registry) ─────────────────────────
const noticesApi = ApiBlueprint.make({
  name: 'notices-api',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: noticesApiRef,
        deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
        factory: ({ discoveryApi, fetchApi }) =>
          new NoticesRestApi({ discoveryApi, fetchApi }),
      }),
    ),
});

// ── Admin page (→ app/routes) ───────────────────────────
const noticesPage = PageBlueprint.make({
  params: {
    path: NOTICES_BASE_PATH,
    routeRef: rootRouteRef,
    noHeader: true,
    loader: () =>
      import('./pages/NoticesPage').then(m => (
        <RequirePermission permission={noticesReadPermission}>
          <m.NoticesPage />
        </RequirePermission>
      )),
  },
});

// ── Pop-up (→ app root) ─────────────────────────────────
const noticesPopUp = AppRootElementBlueprint.make({
  name: 'pop-up',
  params: {
    element: <NoticesPopUp />,
  },
});

export default createFrontendPlugin({
  info: {
    packageJson: () => import('../package.json'),
    manifest: () => import('../catalog-info.yaml'),
  },
  pluginId: 'neo4j-notices',
  extensions: [noticesApi, noticesPage, noticesPopUp],
  routes: {
    root: rootRouteRef,
  },
});
